import React from 'react';
import I18n from '@/modules/i18n';
import { Button } from '@/components/ui/Buttons';
import { useModalManager } from '@/components/common/Modal';
import { queryClient } from '@/utils/ReactQuery';
import { useQuestionRubric } from './useQuestionRubric';
import UseExistingRubricModal from './UseExistingRubricModal';

interface IReuseRubricButtonProps {
  questionId: number;
}

const ReuseRubricButton = ({ questionId }: IReuseRubricButtonProps) => {
  const { close, isOpen, open } = useModalManager();
  const { data, isFetching } = useQuestionRubric({ questionId });

  if (isFetching || data) return null;

  const handleSuccess = () => {
    queryClient.invalidateQueries(['useRubric', { for_question: questionId }]);
  };

  return (
    <>
      <Button small color="green" onClick={open}>{I18n.t('reuse_rubric')}</Button>
      <UseExistingRubricModal
        isOpen={isOpen}
        questionId={questionId}
        onClose={close}
        onSuccess={handleSuccess}
      />
    </>
  );
};

export default ReuseRubricButton;
